module.exports = __webpack_public_path__ + "img/yzc.011b2cdf.png";